export const SHOP_RULES = {
  healPrice: 60,
  healFraction: 0.5,
} as const;
